import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ClosedButtonSettings from 'Pods/ThreeDStudio/Shared/ClosedButtonSettings/ClosedButtonSettings'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { MATERIAL } from 'Pods/ThreeDStudio/Store/constants'

const labelKeys = {
  [MATERIAL.PBR]: 'leftSide.material.pbr',
  [MATERIAL.BASIC]: 'leftSide.material.basic',
  [MATERIAL.GEOMETRY_ONLY]: 'leftSide.material.geometry',
}

function CollapsedMaterialRow() {
  const t = useTranslation()
  const material = useThreeDStudioStore(state => state.modelSettings.material)
  const labelKey = labelKeys[material]
  const buttonLabel = labelKey ? t(labelKey) : ''
  const isActive = Boolean(buttonLabel)

  return (
    <ClosedButtonSettings
      label={t('leftSide.material.label')}
      isActive={isActive}
      buttonLabel={buttonLabel}
    />
  )
}

export default memo(CollapsedMaterialRow)
